import React from "react";
import Link from "next/link";
import {Badge} from "@/components/ui/badge";
import { ShoppingBag } from 'lucide-react';
import useCart from "@/hooks/useCart";

export default function BtnCart() {
    const { totalQuantity } = useCart();

    return (
        <a href={'/shop/cart'} aria-label="BtnCart"
                className={'flex items-center bg-white hover:text-blue-700'}>
            <div className="relative inline-block">
                <ShoppingBag />
                {totalQuantity > 0 && (
                    <Badge className="absolute -top-2 -right-2 h-5 min-w-5 flex items-center justify-center px-1 text-xs bg-blue-600 text-white">
                        {totalQuantity}
                    </Badge>
                )}
            </div>
        </a>
    )
}
